import { CardSvg } from '@/play/cardSvg'

/** Home card art: a chrome drop melting into a puddle on a slate plinth, with a droplet beside it. */
export function FlowingMetalCardArt() {
  return (
    <CardSvg bg="#d9dde3">
      {(id) => (
        <>
          <defs>
            <radialGradient id={id('chrome')} cx="0.38" cy="0.3" r="0.85">
              <stop offset="0" stopColor="#ffffff" />
              <stop offset="0.3" stopColor="#dfe5ea" />
              <stop offset="0.62" stopColor="#59636e" />
              <stop offset="0.86" stopColor="#2a3038" />
              <stop offset="1" stopColor="#b9c3cc" />
            </radialGradient>
          </defs>
          <path d="M20 160 L 300 160 L 320 200 L 0 200 Z" fill="#3c434c" />
          <ellipse cx="160" cy="160" rx="110" ry="16" fill={`url(#${id('chrome')})`} />
          {/* The neck where the drop melts into the puddle. */}
          <path d="M96 160 C 116 158, 112 140, 122 128 L 198 128 C 208 140, 204 158, 224 160 Z" fill={`url(#${id('chrome')})`} />
          <ellipse cx="160" cy="104" rx="62" ry="56" fill={`url(#${id('chrome')})`} />
          <circle cx="252" cy="148" r="9" fill={`url(#${id('chrome')})`} />
        </>
      )}
    </CardSvg>
  )
}
